﻿
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-tabs">
    <div class="dsk-tab dsk-pulse" *ngFor="let t of [1,2,3]"></div>
  </div>
  <div class="dsk-split dsk-split-1-2" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-search dsk-pulse" style="flex:1"></div>
      </div>
      <div class="dsk-panel-body" style="gap:8px;padding:10px 12px">
        <div *ngFor="let t of [1,2,3,4,5,6,7]" style="display:flex;align-items:center;gap:10px;padding:12px 14px;background:#faf8ff;border-radius:10px;border:1px solid #e8e5e2">
          <div class="dsk-avatar dsk-pulse" style="width:40px;height:40px;border-radius:10px"></div>
          <div style="flex:1;display:flex;flex-direction:column;gap:5px">
            <div class="dsk-cell dsk-pulse" style="width:110px;height:14px"></div>
            <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
          </div>
          <div style="display:flex;gap:-6px">
            <div class="dsk-avatar dsk-pulse" style="width:26px;height:26px;border-radius:50%;margin-left:-4px" *ngFor="let a of [1,2,3]"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="dsk-panel">
      <div style="padding:18px 20px;background:#faf8ff;border-bottom:1px solid #e8e5e2;display:flex;align-items:center;gap:14px">
        <div class="dsk-avatar dsk-pulse" style="width:52px;height:52px;border-radius:12px"></div>
        <div style="flex:1;display:flex;flex-direction:column;gap:7px">
          <div class="dsk-cell dsk-pulse" style="width:150px;height:17px"></div>
          <div class="dsk-cell dsk-pulse" style="width:100px;height:12px"></div>
        </div>
        <div class="dsk-badge dsk-pulse" style="width:80px;height:28px;border-radius:20px"></div>
      </div>
      <div style="padding:16px 20px;display:flex;flex-direction:column;gap:10px">
        <div *ngFor="let m of [1,2,3,4,5,6]" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid #f0eeec">
          <div class="dsk-avatar dsk-pulse" style="border-radius:50%"></div>
          <div style="flex:1;display:flex;flex-direction:column;gap:5px">
            <div class="dsk-cell dsk-pulse" style="width:120px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
          </div>
          <div class="dsk-cell dsk-pulse" style="width:90px;height:13px"></div>
          <div class="dsk-badge dsk-pulse" style="width:62px;border-radius:20px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ts-page" *ngIf="!loading">
  <div class="np-tabs" *ngIf="!embedTab">
    <button class="np-tab" [class.active]="activeTab==='list'" (click)="switchTab('list')">All Teams</button>
    <button class="np-tab" [class.active]="activeTab==='shifts'" (click)="switchTab('shifts')">Shift Definitions</button>
  </div>

  <div *ngIf="activeTab === 'list'" class="teams-layout">

    <div class="teams-list-col">
      <div class="tl-header">
        <span class="tl-title">All Teams</span>
        <button class="tl-new-btn" (click)="showCreateTeam=true" *ngIf="permissions.canAddInModule('teams')">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          New Team
        </button>
      </div>

      <div class="team-card-list">
        <div
          class="tl-card"
          *ngFor="let t of teams"
          [class.tl-card--active]="selectedTeam?.id === t.id"
          (click)="selectTeam(t)"
        >
          <div class="tl-card-top">
            <div class="tl-card-info">
              <div class="tl-card-name">{{ t.name }}</div>
              <div class="tl-card-sub">{{ getShiftName(t.defaultShiftId) }} shift · {{ getLeadName(t.teamLeadId) }}</div>
            </div>
            <span class="bd" [ngClass]="t.status === 'active' ? 'bgr' : 'bcr'" style="font-size:9.5px">{{ t.status | titlecase }}</span>
          </div>
          <div class="tl-card-bottom">
            <div class="tl-avatars">
              <div class="tc-av" *ngFor="let m of (teamMembersMap[t.id] || []).slice(0, 4)" [style.background]="getAvatarColor(getLeadName(m.employeeId))">{{ getEmpInitials(getLeadName(m.employeeId)) }}</div>
              <div class="tc-more" *ngIf="(teamMembersMap[t.id] || []).length > 4">+{{ (teamMembersMap[t.id] || []).length - 4 }}</div>
            </div>
            <span class="tl-count">{{ (teamMembersMap[t.id] || []).length }} members</span>
          </div>
        </div>

        <div class="tl-empty" *ngIf="teams.length === 0">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:8px"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
          <span>No teams yet</span>
          <button class="btn-primary" style="margin-top:10px;font-size:11px;padding:7px 14px" (click)="showCreateTeam=true">Create First Team</button>
        </div>
      </div>
    </div>

    <div class="team-detail-panel" [class.team-detail-panel--visible]="selectedTeam">

      <div class="tdp-empty" *ngIf="!selectedTeam">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" style="color:#d4c8c5;margin-bottom:12px"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
        <div class="tdp-empty-title">Select a team</div>
        <div class="tdp-empty-sub">Click any team on the left to view its members and details</div>
      </div>

      <ng-container *ngIf="selectedTeam">
        <div class="tdp-head">
          <div class="tdp-head-left">
            <div class="tdp-avatar" [style.background]="getAvatarGradient(selectedTeam.name)">{{ getEmpInitials(selectedTeam.name) }}</div>
            <div>
              <div class="tdp-name">{{ selectedTeam.name }}</div>
              <div class="tdp-meta">
                <span class="bd" [ngClass]="selectedTeam.status === 'active' ? 'bgr' : 'bcr'" style="font-size:9.5px">{{ selectedTeam.status | titlecase }}</span>
                <span class="tdp-dot">·</span>
                <span class="tdp-shift-badge">{{ getShiftName(selectedTeam.defaultShiftId) }}</span>
              </div>
            </div>
          </div>
          <div class="tdp-actions">
            <button class="tdp-action-btn" (click)="showAddMember = true" title="Add Member">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
              Add Member
            </button>
            <button class="tdp-icon-btn" (click)="openEditTeam(selectedTeam)" title="Edit Team">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="tdp-icon-btn tdp-icon-btn--danger" (click)="deleteTeam(selectedTeam.id)" title="Delete Team">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>
            </button>
          </div>
        </div>

        <div class="tdp-info-strip">
          <div class="tdp-info-item">
            <span class="tdp-info-label">Lead</span>
            <span class="tdp-info-val">{{ getLeadName(selectedTeam.teamLeadId) }}</span>
          </div>
          <div class="tdp-info-sep"></div>
          <div class="tdp-info-item">
            <span class="tdp-info-label">Members</span>
            <span class="tdp-info-val">{{ (teamMembersMap[selectedTeam.id] || []).length }}</span>
          </div>
          <div class="tdp-info-sep"></div>
          <div class="tdp-info-item">
            <span class="tdp-info-label">Shift</span>
            <span class="tdp-info-val">{{ getShiftName(selectedTeam.defaultShiftId) }}</span>
          </div>
        </div>

        <div class="tdp-section-label">
          <span>Members</span>
          <span class="tdp-section-count">{{ (teamMembersMap[selectedTeam.id] || []).length }}</span>
        </div>

        <div class="tdp-members">
          <div class="tdp-member-row" *ngFor="let m of teamMembersMap[selectedTeam.id] || []">
            <div class="av" [style.background]="getAvatarColor(getLeadName(m.employeeId))">{{ getEmpInitials(getLeadName(m.employeeId)) }}</div>
            <div class="tdp-member-info">
              <div class="tdp-member-name">{{ getLeadName(m.employeeId) }}</div>
              <div class="tdp-member-sub">{{ getEmployee(m.employeeId)?.designation || getEmployee(m.employeeId)?.employeeId || '—' }}</div>
            </div>
            <span class="bd" [ngClass]="getEmployee(m.employeeId)?.status === 'active' ? 'bgr' : 'brr'" style="font-size:9px;margin-left:auto;margin-right:8px">{{ (getEmployee(m.employeeId)?.status || 'active') | titlecase }}</span>
            <button class="tdp-remove-btn" (click)="removeTeamMember(selectedTeam.id, m.employeeId)" title="Remove">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="tdp-no-members" *ngIf="(teamMembersMap[selectedTeam.id] || []).length === 0">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:6px"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
            <span>No members yet</span>
            <button class="btn-primary" style="margin-top:8px;font-size:11px;padding:6px 14px" (click)="showAddMember = true">Add First Member</button>
          </div>
        </div>

      </ng-container>
    </div>

    <div class="sd-overlay" [class.open]="showEditTeam" (click)="showEditTeam = false"></div>
    <div class="sd-drawer" [class.open]="showEditTeam">
      <div class="sd-head">
        <div class="sd-head-info">
          <div class="sd-head-title">Edit Team</div>
          <div class="sd-head-sub">Update team details and settings</div>
        </div>
        <button class="sd-close" (click)="showEditTeam = false">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>
      <div class="sd-body">
        <div class="fg">
          <label class="fl">Team Name <span class="sd-req">*</span></label>
          <input class="fi" [(ngModel)]="editTeamForm.name" placeholder="e.g. Team Phoenix"/>
        </div>
        <div class="fg">
          <label class="fl">Department</label>
          <app-custom-select [(ngModel)]="editTeamForm.departmentId" [options]="departments" bindValue="id" bindLabel="name" placeholder="Select department"></app-custom-select>
        </div>
        <div class="fg">
          <label class="fl">Team Lead</label>
          <app-custom-select [(ngModel)]="editTeamForm.teamLeadId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select lead"></app-custom-select>
        </div>
        <div class="fg">
          <label class="fl">Default Shift</label>
          <app-custom-select [(ngModel)]="editTeamForm.defaultShiftId" [options]="shifts" bindValue="id" [labelFn]="shiftLabelFn" placeholder="Select shift"></app-custom-select>
        </div>
        <div class="fg">
          <label class="fl">Status</label>
          <app-custom-select [(ngModel)]="editTeamForm.status" [options]="teamStatusOptions" placeholder="Select status"></app-custom-select>
        </div>
        <div class="fg">
          <label class="fl">Description</label>
          <textarea class="fi" [(ngModel)]="editTeamForm.description" placeholder="Team description…" rows="3"></textarea>
        </div>
      </div>
      <div class="sd-foot">
        <button class="btn-primary" (click)="saveEditTeam()" [disabled]="submitting || !editTeamForm.name">{{ submitting ? 'Saving…' : 'Save Changes' }}</button>
        <button class="btn-outline" (click)="showEditTeam = false">Cancel</button>
      </div>
    </div>

    <div class="modal-overlay" *ngIf="showAddMember" (click)="showAddMember = false">
      <div class="modal" (click)="$event.stopPropagation()">
        <div class="modal-hd">
          <span class="modal-title">Add Member to {{ selectedTeam?.name }}</span>
          <button class="modal-close" (click)="showAddMember = false">=</button>
        </div>
        <div class="fg">
          <label class="fl">Select Employee</label>
          <app-custom-select [(ngModel)]="addMemberEmployeeId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select employee"></app-custom-select>
        </div>
        <button class="btn-primary" (click)="addTeamMember()" [disabled]="!addMemberEmployeeId">Add Member</button>
      </div>
    </div>

  </div>

  <div class="sd-overlay" [class.open]="showCreateTeam" (click)="showCreateTeam=false"></div>
  <div class="sd-drawer" [class.open]="showCreateTeam">
    <div class="sd-head">
      <div class="sd-head-info">
        <div class="sd-head-title">New Team</div>
        <div class="sd-head-sub">Fill in the details to create a team</div>
      </div>
      <button class="sd-close" (click)="showCreateTeam=false">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="sd-body">
      <div class="fg">
        <label class="fl">Team Name <span class="sd-req">*</span></label>
        <input class="fi" [(ngModel)]="teamForm.name" placeholder="e.g. Team Phoenix"/>
      </div>
      <div class="fg">
        <label class="fl">Department</label>
        <app-custom-select [(ngModel)]="teamForm.departmentId" [options]="departments" bindValue="id" bindLabel="name" placeholder="Select department (optional)"></app-custom-select>
      </div>
      <div class="fg">
        <label class="fl">Team Lead <span class="sd-req">*</span></label>
        <app-custom-select [(ngModel)]="teamForm.teamLeadId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select lead"></app-custom-select>
      </div>
      <div class="fg">
        <label class="fl">Default Shift</label>
        <app-custom-select [(ngModel)]="teamForm.defaultShiftId" [options]="shifts" bindValue="id" [labelFn]="shiftLabelFn" placeholder="Select shift"></app-custom-select>
      </div>
      <div class="fg">
        <label class="fl">Description</label>
        <textarea class="fi" [(ngModel)]="teamForm.description" placeholder="Brief team purpose…" rows="3"></textarea>
      </div>

      <div class="ct-members-section">
        <div class="ct-members-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
          <span>Add Members</span>
          <span class="ct-added-badge" *ngIf="pendingMembers.length">{{ pendingMembers.length }}</span>
        </div>

        <div class="ct-added-chips" *ngIf="pendingMembers.length > 0">
          <div class="ct-chip" *ngFor="let m of pendingMembers">
            <div class="ct-chip-av" [style.background]="getAvatarColor(m.firstName + ' ' + m.lastName)">{{ getEmpInitials(m.firstName + " " + m.lastName) }}</div>
            <span class="ct-chip-name">{{ m.firstName }} {{ m.lastName }}</span>
            <button class="ct-chip-remove" (click)="removePendingMember(m.id)">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
        </div>

        <div class="ct-search-wrap">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" class="ct-search-icon"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input class="ct-search-input" [(ngModel)]="memberSearch" placeholder="Search employees by name or department…"/>
        </div>

        <div class="ct-emp-list">
          <div class="ct-emp-row" *ngFor="let e of filteredEmployeesForAdd">
            <div class="ct-emp-av" [style.background]="getAvatarColor(e.firstName + ' ' + e.lastName)">{{ getEmpInitials(e.firstName + " " + e.lastName) }}</div>
            <div class="ct-emp-info">
              <div class="ct-emp-name">{{ e.firstName }} {{ e.lastName }}</div>
              <div class="ct-emp-dept">{{ getEmpDeptName(e) || '—' }}</div>
            </div>
            <button class="ct-add-btn" (click)="addPendingMember(e)">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Add
            </button>
          </div>
          <div class="ct-emp-empty" *ngIf="filteredEmployeesForAdd.length === 0">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:4px"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <span>No employees match your search</span>
          </div>
        </div>
      </div>
    </div>
    <div class="sd-foot">
      <button class="btn-primary" (click)="createTeam()" [disabled]="submitting || !teamForm.name">{{ submitting ? 'Creating…' : 'Create Team' }}</button>
      <button class="btn-outline" (click)="showCreateTeam=false">Cancel</button>
    </div>
  </div>

  <div *ngIf="activeTab === 'assign'" class="assign-page">
    <div class="as-layout">

      <div class="as-form-card">

        <div class="as-card-tabs">
          <button class="as-card-tab" [class.as-card-tab--active]="assignMode==='team'" (click)="assignMode='team'">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            Assign to Team
          </button>
          <button class="as-card-tab" [class.as-card-tab--active]="assignMode==='employee'" (click)="assignMode='employee'">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            Assign to Employee
          </button>
        </div>

        <div class="as-form-body">

          <ng-container *ngIf="assignMode==='team'">
            <div class="as-form-desc">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;color:#b45309"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Applies to all members — individual overrides remain possible
            </div>
            <div class="fg">
              <label class="fl">Select Team <span class="sd-req">*</span></label>
              <app-custom-select [(ngModel)]="teamShiftForm.teamId" [options]="teams" bindValue="id" [labelFn]="teamLabelFn" placeholder="Select a team"></app-custom-select>
            </div>
            <div class="fg">
              <label class="fl">Assign Shift <span class="sd-req">*</span></label>
              <app-custom-select [(ngModel)]="teamShiftForm.shiftId" [options]="shifts" bindValue="id" [labelFn]="shiftLabelFn" placeholder="Select shift"></app-custom-select>
            </div>
            <div class="fg">
              <label class="fl">Effective From <span class="sd-req">*</span></label>
              <input type="date" class="fi" [(ngModel)]="teamShiftForm.effectiveFrom"/>
            </div>
            <div class="fg">
              <label class="fl">Override individual assignments?</label>
              <app-custom-select [(ngModel)]="teamShiftForm.override" [options]="overrideOptions" placeholder="Select option"></app-custom-select>
            </div>
            <div class="fg">
              <label class="fl">Notes</label>
              <input class="fi" [(ngModel)]="teamShiftForm.notes" placeholder="Reason for shift change…"/>
            </div>
            <button class="as-submit-btn" (click)="assignShiftToTeam()" [disabled]="submitting || !teamShiftForm.teamId || !teamShiftForm.shiftId">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              {{ submitting ? 'Assigning…' : 'Assign to Entire Team' }}
            </button>
          </ng-container>

          <ng-container *ngIf="assignMode==='employee'">
            <div class="as-form-desc">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;color:#b45309"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              Override an employee's team shift with an individual schedule
            </div>
            <div class="fg">
              <label class="fl">Employee <span class="sd-req">*</span></label>
              <app-custom-select [(ngModel)]="empShiftForm.employeeId" [options]="employees" bindValue="id" [labelFn]="empNameFn" placeholder="Select employee"></app-custom-select>
            </div>
            <div class="fg">
              <label class="fl">Assign Shift <span class="sd-req">*</span></label>
              <app-custom-select [(ngModel)]="empShiftForm.shiftId" [options]="shifts" bindValue="id" [labelFn]="shiftLabelFn" placeholder="Select shift"></app-custom-select>
            </div>
            <div class="fg">
              <label class="fl">Effective From <span class="sd-req">*</span></label>
              <input type="date" class="fi" [(ngModel)]="empShiftForm.effectiveFrom"/>
            </div>
            <div class="fg">
              <label class="fl">Effective Until <span style="font-weight:400;color:#b0a09e">(optional)</span></label>
              <input type="date" class="fi" [(ngModel)]="empShiftForm.effectiveUntil"/>
            </div>
            <div class="fg">
              <label class="fl">Reason for Change</label>
              <input class="fi" [(ngModel)]="empShiftForm.reason" placeholder="e.g. Project requirement"/>
            </div>
            <button class="as-submit-btn" (click)="assignShiftToEmployee()" [disabled]="submitting || !empShiftForm.employeeId || !empShiftForm.shiftId">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              {{ submitting ? 'Assigning…' : 'Assign Shift' }}
            </button>
          </ng-container>

        </div>
      </div>

      <div class="as-preview-col">

        <ng-container *ngIf="assignMode==='team'">
          <div class="as-preview-hero" *ngIf="!teamShiftForm.teamId">
            <div class="as-preview-hero-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <div class="as-preview-hero-title">Select a team</div>
            <div class="as-preview-hero-sub">Members will appear here as a live preview of what will change</div>
          </div>

          <ng-container *ngIf="teamShiftForm.teamId">
            <div class="as-preview-head">
              <div class="as-preview-head-left">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
                Affected Members
              </div>
              <span class="as-count-badge">{{ (teamMembersMap[teamShiftForm.teamId] || []).length }}</span>
            </div>

            <div class="as-change-banner" *ngIf="teamShiftForm.shiftId">
              <div class="as-change-from">Current shift</div>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="color:#a07055;flex-shrink:0"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              <div class="as-change-to">{{ getShiftName(teamShiftForm.shiftId) }}</div>
            </div>

            <div class="as-member-list">
              <div class="as-member-row" *ngFor="let m of teamMembersMap[teamShiftForm.teamId] || []">
                <div class="as-mem-av" [style.background]="getAvatarColor(getLeadName(m.employeeId))">{{ getEmpInitials(getLeadName(m.employeeId)) }}</div>
                <div class="as-member-info">
                  <div class="as-member-name">{{ getLeadName(m.employeeId) }}</div>
                  <div class="as-shift-flow">
                    <span class="as-shift-cur">{{ getMemberCurrentShift(m.employeeId) }}</span>
                    <svg *ngIf="teamShiftForm.shiftId" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" style="color:#a07055;flex-shrink:0"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                    <span class="as-shift-new" *ngIf="teamShiftForm.shiftId">{{ getShiftName(teamShiftForm.shiftId) }}</span>
                  </div>
                </div>
              </div>
              <div class="as-preview-hero" *ngIf="(teamMembersMap[teamShiftForm.teamId] || []).length === 0">
                <div class="as-preview-hero-sub">No members in this team</div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="assignMode==='employee'">
          <div class="as-preview-head">
            <div class="as-preview-head-left">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              Current Assignments
            </div>
            <span class="as-count-badge">{{ assignments.length }}</span>
          </div>

          <div class="as-preview-hero" *ngIf="assignments.length === 0">
            <div class="as-preview-hero-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <div class="as-preview-hero-title">No assignments yet</div>
            <div class="as-preview-hero-sub">Individual shift overrides will appear here</div>
          </div>

          <div class="as-assign-list" *ngIf="assignments.length > 0">
            <div class="as-assign-row" *ngFor="let a of assignments">
              <div class="as-mem-av" [style.background]="getAvatarColor(a.employeeName)">{{ getEmpInitials(a.employeeName) }}</div>
              <div class="as-member-info">
                <div class="as-member-name">{{ a.employeeName }}</div>
                <div class="as-assign-meta" *ngIf="a.effectiveFrom">From {{ a.effectiveFrom }}</div>
              </div>
              <span class="as-shift-badge">{{ a.shiftName }}</span>
            </div>
          </div>
        </ng-container>

      </div>
    </div>
  </div>

  <div *ngIf="activeTab === 'shifts'" class="sd-page">

    <div class="sd-page-header">
      <div>
        <div class="sd-page-title">Shift Definitions</div>
        <div class="sd-page-sub">{{ shifts.length }} shift{{ shifts.length !== 1 ? 's' : '' }} configured</div>
      </div>
      <button class="btn-primary" style="display:inline-flex;align-items:center;gap:6px;font-size:12px;padding:8px 16px" *ngIf="permissions.canAddInModule('teams')" (click)="showAddShift=true">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        New Shift
      </button>
    </div>

    <div class="sd-cards-grid">
      <div class="sd-card" *ngFor="let s of shifts; let i = index">
        <div class="sd-card-bar" [style.background]="getShiftBadgeColor(i)"></div>

        <div class="sd-card-body">
          <div class="sd-card-top">
            <div class="sd-card-name">{{ s.name }}</div>
            <span class="sd-card-badge" [style.background]="getShiftBadgeColor(i)" [style.color]="getShiftTextColor(i)">
              {{ i === 0 ? 'Default' : 'Active' }}
            </span>
          </div>

          <div class="sd-card-time" *ngIf="s.startTime">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;opacity:.6"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>{{ formatTime12(s.startTime) }}</span>
            <span class="sd-card-time-sep">=</span>
            <span>{{ formatTime12(s.endTime) }}</span>
          </div>
          <div class="sd-card-time sd-card-time--flex" *ngIf="!s.startTime">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;opacity:.6"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            Flexible hours
          </div>

          <div class="sd-card-chips">
            <span class="sd-chip sd-chip--days" *ngIf="s.workingDays">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              {{ s.workingDays }}
            </span>
            <span class="sd-chip sd-chip--grace" *ngIf="s.graceMinutes">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              {{ s.graceMinutes }}m grace
            </span>
            <span class="sd-chip sd-chip--break" *ngIf="s.breakMinutes">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 8h1a4 4 0 010 8h-1"/><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z"/><line x1="6" y1="1" x2="6" y2="4"/><line x1="10" y1="1" x2="10" y2="4"/><line x1="14" y1="1" x2="14" y2="4"/></svg>
              {{ s.breakMinutes }}m break
            </span>
          </div>
        </div>
      </div>

      <div class="sd-card sd-card--add" (click)="showAddShift=true" *ngIf="permissions.canAddInModule('teams')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" style="color:#c9b8b4;margin-bottom:8px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        <span>New Shift</span>
      </div>
    </div>

  </div>
</div>

<div class="sd-overlay" [class.open]="showAddShift" (click)="resetShiftForm()"></div>
<div class="sd-drawer" [class.open]="showAddShift">
  <div class="sd-head">
    <div class="sd-head-info">
      <div class="sd-head-title">New Shift</div>
      <div class="sd-head-sub">Define working hours and rules</div>
    </div>
    <button class="sd-close" (click)="resetShiftForm()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="fg">
      <label class="fl">Shift Name <span class="sd-req">*</span></label>
      <input class="fi" [(ngModel)]="shiftForm.name" placeholder="e.g. Morning Shift"/>
    </div>
    <div class="fg">
      <label class="fl">Start Time</label>
      <div class="time-selects">
        <select class="fi time-sel" [(ngModel)]="startHour"><option *ngFor="let h of hours" [value]="h">{{ h }}</option></select>
        <span class="time-colon">:</span>
        <select class="fi time-sel" [(ngModel)]="startMin"><option *ngFor="let m of minutes" [value]="m">{{ m }}</option></select>
      </div>
    </div>
    <div class="fg">
      <label class="fl">End Time</label>
      <div class="time-selects">
        <select class="fi time-sel" [(ngModel)]="endHour"><option *ngFor="let h of hours" [value]="h">{{ h }}</option></select>
        <span class="time-colon">:</span>
        <select class="fi time-sel" [(ngModel)]="endMin"><option *ngFor="let m of minutes" [value]="m">{{ m }}</option></select>
      </div>
    </div>
    <div class="fg">
      <label class="fl">Working Days</label>
      <app-custom-select [(ngModel)]="shiftForm.workingDays" [options]="workingDaysOptions" placeholder="Select days"></app-custom-select>
    </div>
    <div class="form-row">
      <div class="fg">
        <label class="fl">Grace Period (min)</label>
        <input type="number" class="fi" [(ngModel)]="shiftForm.graceMinutes" placeholder="15"/>
      </div>
      <div class="fg">
        <label class="fl">Break Duration (min)</label>
        <input type="number" class="fi" [(ngModel)]="shiftForm.breakMinutes" placeholder="60"/>
      </div>
    </div>
  </div>
  <div class="sd-foot">
    <button class="btn-primary" (click)="addShift()" [disabled]="submitting || !shiftForm.name">{{ submitting ? 'Creating…' : 'Create Shift' }}</button>
    <button class="btn-outline" (click)="resetShiftForm()">Cancel</button>
  </div>
</div>

<div *ngIf="loading" class="loading-container">
  <mat-spinner diameter="40"></mat-spinner>
</div>

